import React, { useEffect } from 'react';

import WithDrawer from 'Components/Templates/WithDrawer';
import PageContainer from 'Components/Atoms/PageContainer';
import PayrollSettingsKimaiAPI from 'Components/Organisms/PayrollSettingsKimaiAPI';
import PayrollSettingsManualTriggering from 'Components/Organisms/PayrollSettingsManualTriggering';

const PayrollSettings: React.FC = () => {
  useEffect(() => {
    document.title = 'Payroll Settings - Orion';
  }, []);

  return (
    <WithDrawer>
      <PageContainer>
        <PayrollSettingsManualTriggering />
        <PayrollSettingsKimaiAPI />
      </PageContainer>
    </WithDrawer>
  );
};

export default PayrollSettings;
